/**
 *
 * @param {string} groupId
 * @param {object} user
 * @returns {boolean} if the user is admin, returns true. Otherwise, returns false.
 */
export const isSuperAdmin = (groupId, user) => {
  const currentGroupPermission = user?.permissions?.find((permission) => permission.groupId === groupId && permission.role === "ROLE_ADMI");
  return !!currentGroupPermission?.isSuperAdmin;
};

export const isAdmin = (groupId, user) => {
  const permission = user?.permissions && user.permissions.find((_permission) => {
    return _permission.groupId === groupId;
  });
  if (permission?.role === "ROLE_ADMI") {
    return true;
  } else {
    return false;
  }
};

export const isPublisher = (groupId, user) => {
  const permission = user?.permissions && user.permissions.find((_permission) => {
    return _permission.groupId === groupId;
  });
  if (permission?.role === "ROLE_PUBLISHER") {
    return true;
  } else {
    return false;
  }
};

/**
 *
 * @param {object} user
 * @returns {boolean} if the user is publisher in all groups, returns true. Otherwise, returns false.
 */
export const isPublisherAllGroups = (user) => {
  var publisherAllGroups = true;
  for (let i = 0; i < user.permissions.length; i++) {
    const _permission = user.permissions[i];
    if (_permission.role != "ROLE_PUBLISHER") {
      publisherAllGroups = false;
      break;
    }
  }
  return publisherAllGroups;
};

/**
 * Checks if the user is a supervisor (read-only admin with multi-team access)
 * @param {string} groupId
 * @param {object} user
 * @returns {boolean} if the user is supervisor, returns true. Otherwise, returns false.
 */
export const isSupervisor = (groupId, user) => {
  const permission = user?.permissions?.find((p) =>
    p.groupId === groupId &&
    p.role === "ROLE_ADMI" &&
    p.isSuperAdmin !== true &&  // NOT a superadmin
    p.isSupervisor === true
  );
  return !!permission;
};

export const canUseTemplates = (groupId, user, currentGroup, currentContact) => {
  // 0. Si el grupo no tiene "hasTemplateModule" definido, se puede usar plantillas libremente
  if (currentGroup?.hasTemplateModule === undefined) {
    return true;
  }

  // 1. Superadmin siempre puede usar plantillas
  if (isSuperAdmin(groupId, user)) {
    // console.log("✅ Usuario es superadmin - puede usar plantillas");
    return true;
  }

  // 2. Obtener configuraciones
  const userPermission = user?.permissions?.find(p => p.groupId === groupId);
  const hasTemplatePermission = userPermission?.hasTemplatePermission;
  const groupTemplateRestrictionForPublisher = currentGroup?.templateRestrictionForPublisher;

  // 3. Si usuario tiene permiso explícito TRUE, permitir sin restricciones
  if (hasTemplatePermission === true) {
    // console.log("✅ Usuario tiene permiso explícito TRUE - puede usar plantillas");
    return true;
  }

  // // 4. Si usuario tiene permiso explícito FALSE, validar tiempo del chat
  // if (hasTemplatePermission === false) {
  //   const lastContactResponseAt = currentContact?.lastContactResponseAt;
  //   if (!lastContactResponseAt) {
  //     // console.log("❌ Usuario no tiene permiso explícito FALSE - no puede usar plantillas");
  //     return false;
  //   }

  //   const lastResponse = new Date(lastContactResponseAt);
  //   const now = new Date();
  //   const diffMs = now - lastResponse;
  //   const timeLimit = 24 * 60 * 60 * 1000; // 24 horas
  //   const remainingMs = timeLimit - diffMs;

  //   return remainingMs > 0;
  // }

  // 5. Usuario sin permiso explícito - evaluar configuración del grupo
  if (groupTemplateRestrictionForPublisher === true) {
    // console.log("✅ Grupo habilitó módulo de plantillas");
    return false;
  }

  if (groupTemplateRestrictionForPublisher === false) {
    // console.log("❌ Grupo deshabilitó módulo de plantillas");
    return true; // Permitir siempre si grupo lo habilita y usuario no tiene restricción
  }

  // 6. Sin configuración - permitir por defecto
  // console.log("✅ Sin configuración - permitir por defecto");
  return true;
};
